module.exports = __webpack_public_path__ + "media/images/talent/case01-badge-6594df93f56e8e999521a3f11ac3b211.png";